import React, { useEffect, useState, useMemo } from "react";
import { type State, defaultState } from "./types";
import { normalizeText } from "./utils";
import Controls from "./Controls";
import Items from "./Items";
// import Loading from "./Loading";

// Fix para que funciona ReactJson
const ReactJsonView = typeof window !== `undefined` ? require("react-json-view").default : null;

interface Props {
    items: any[];
    loading: boolean;
}

const Component = ({ items, loading }: Props) => {
    // Estado del componente
    const [state, setState] = useState<State>(defaultState);

    // Memorizar items para evitar renderizados infinitos y mejorar performance.
    // También ocultamos los items que tienen un parent, ya que serán un subproducto.
    const memoizedAllItems = useMemo(() => items, [items]);

    // Filtramos los items que no tienen parent
    const memoizedItems = useMemo(() => items.filter(item => !item.parent), [items]);

    // Actualizamos el estado después de que se calcule memoizedItems y memoizedAllItems
    useEffect(() => {
        setState(prevState => ({
            ...prevState,
            items: memoizedItems,
            allItems: memoizedAllItems,
            loading,
        }));
    }, [memoizedItems, memoizedAllItems, loading]);

    // Filtramos por stockFilter y textFilter en caso que
    // haya algún valor modificado
    useEffect(() => {
        // Filtramos por stockFilter y textFilter en caso
        // que haya algún valor y lo guardamos en el estado.
        let filteredItems = memoizedItems;

        // Filtramos los items que no tienen stock
        if (state.noStockFilter) {
            filteredItems = filteredItems.filter(item => item.stock);
        }

        // Filtramos por el texto ingresado en el input
        if (state.textFilter) {
            const normalizedTextFilter = normalizeText(state.textFilter);
            filteredItems = filteredItems.filter(item =>
                normalizeText(item.name).includes(normalizedTextFilter),
            );
        }

        // Actualizamos el estado con los items filtrados
        setState(prevState => ({ ...prevState, items: filteredItems }));
    }, [state.noStockFilter, state.textFilter, memoizedItems, memoizedAllItems]);

    return (
        <section className="space-y-10">
            <Controls state={state} setState={setState} />
            <Items state={state} setState={setState} />
            <Resume state={state} />
            {process.env.NODE_ENV === "development" && (
                <ReactJsonView src={state} collapsed={true} />
            )}
        </section>
    );
};

const Resume = ({ state }: { state: any }) => {
    const items = state.items?.filter((item: any) => !item.parent).length || 0;
    const allItems = state.allItems?.filter((item: any) => !item.parent).length || 0;

    // Si no hay items, no mostramos nada
    if (allItems === 0) {
        return null;
    }

    return (
        <div className="text-xs">
            <p className="text-gray-500 text-right">
                <strong>{items}</strong> de <strong>{allItems}</strong> producto/s
            </p>
        </div>
    );
};

export default Component;
